<template>
  <div>
    <md-content>
      <div v-for="(member, id) in $store.state.plot.team" :key="id" class="md-layout md-gutter">
        <div class="md-layout-item md-size-45">
          <md-field :md-counter="false">
            <label for="parcel">{{ $t("teams.name") }}</label>
            <md-input type="text" name="memberName" v-model="member.name" maxlength="50" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-45">
          <md-field :md-counter="false">
            <label for="sub">{{ $t("teams.surname") }}</label>
            <md-input type="text" name="memberSurname" v-model="member.surname" maxlength="50" />
          </md-field>
        </div>
        <div class="md-layout-item md-size-10">
          <md-icon @click.native="removeMember(id)" v-show="btn.rm">clear</md-icon>
        </div>
      </div>
    </md-content>
    <div class="md-layout md-gutter md-alignment-center-center">
      <md-button class="md-raised md-primary" @click="addMember()" v-show="btn.add">{{ $t("teams.addMember") }}</md-button>
    </div>

    <buttons-nav :prev="prev" next step="1" />
  </div>
</template>

<script>
import ButtonsNav from '@/components/ButtonsNav'

export default {
  components: {
    ButtonsNav
  },
  data: () => ({
    btn: {
      rm: false,
      add: true
    },
    edit: false,
    prev: '/',
    next: 'Localization'
  }),
  mounted () {
    // channel with buttons-nav
    this.$on('next', this.save)
    this.$store.state.plot.id === null ? this.edit = false : this.edit = true

    if (this.edit) { // edit
      this.$emit('title', this.$i18n.t('page.team') + ' (' + this.$i18n.t('global.edit') + ')')
      this.checkTeamSize()
    } else { // new
      this.setNewTeam()
    }
  },
  computed: {
    team: function () {
      return this.$store.state.plot.team
    }
  },
  watch: {
    '$store.state.plot.id': function () {
      this.setNewTeam()
    }
  },
  methods: {
    setNewTeam: function () {
      this.$emit('title', this.$i18n.t('page.team') + ' (' + this.$i18n.t('global.new') + ')')
      this.$store.dispatch('plot/getTmp', 'team')
      this.checkTeamSize()
    },

    checkTeamSize: function () {
      if (this.$store.getters['plot/teamLength'] > 1) {
        this.btn.rm = true
        if (this.$store.getters['plot/teamLength'] === 5) {
          this.btn.add = false
        }
      }
    },

    save: function () {
      if (!this.edit) this.$store.dispatch('plot/setTmp', 'team')
      this.$router.push(this.next)
    },

    addMember: function () {
      this.$store.state.plot.team.push({ ...this.$store.state.plot.member })
      this.btn.rm = true
      if (this.$store.getters['plot/teamLength'] === 5) {
        this.btn.add = false
      }
    },

    removeMember: function (memberId) {
      this.$store.state.plot.team.splice(memberId, 1)
      this.btn.add = true
      if (this.$store.getters['plot/teamLength'] === 1) {
        this.btn.rm = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .md-layout {
    .md-layout-item {
      margin-bottom: 10px;
    }
  }
</style>
